import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cartes-bancaires.png")